import { apiAuth, apiResponseType } from ".";

export const getProductGroupsData = (page: number = 1): apiResponseType =>
  apiAuth.get(`lotteries?page=${page}`);

export const registerProductGroupsData = (data) =>
  apiAuth.postForm("/lotteries/store", data) as apiResponseType;
export const deleteProductGroupsData = (tenid: string) =>
  apiAuth.delete(`lotteries/${tenid}/destroy`) as apiResponseType;
export const updateProductGroupsData = (tenid: string, data) =>
  apiAuth.postForm(`lotteries/${tenid}/update`, data) as apiResponseType;

export const getShowProductGroups = (tenid: string) =>
  apiAuth.get(`lotteries/${tenid}/show`) as apiResponseType;

export const searchProductGroupsData = (params: {
  name: string;
}): apiResponseType => apiAuth.get(`lotteries?name=${params.name}`);

export const setStatusProductGroups = (tenid: string) =>
  apiAuth.put(`lotteries/${tenid}/toggle-status`) as apiResponseType;

export const getSelectProductGroups = () =>
  apiAuth.get(`lotteries/select`) as apiResponseType;
